import React, { Component, PropTypes } from "react";
import MenuItems from "./MenuItems";

class Dropdown extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    userData: PropTypes.object,
    currentBrand: PropTypes.object,
    designs: PropTypes.object,
    typeItems: PropTypes.object,
    design: PropTypes.object,
  };
  render() {
    const {
      submenus,
      dropdown,
      depthLevel,
      typeItems,
      design,
      designs,
      userData,
      dispatch,
      currentBrand,
    } = this.props;
    const updatedDepthLevel = depthLevel + 1;
    const dropdownClass =
      updatedDepthLevel > 1 ? "dropdown-submenu" : "dropdown-main";

    return (
      <ul className={`dropdown ${dropdownClass} ${dropdown ? "show" : ""}`}>
        {submenus.map((submenu, index) => (
          <MenuItems
            items={submenu}
            key={index}
            depthLevel={updatedDepthLevel}
            design={design}
            designs={designs}
            userData={userData}
            dispatch={dispatch}
            typeItems={typeItems}
            currentBrand={currentBrand}
          />
        ))}
      </ul>
    );
  }
}

export default Dropdown;
